/**
 * Exports Module
 * 
 * This module re-exports all important functions and types from the various modules.
 * It allows users to import directly from the main module file.
 * 
 * Example:
 * import { reactiveStore, AsReactiveComponent } from 'as-components.v0.0.10.m.js';
 */

// Re-export from store.ts
export { reactiveStore } from './store/store.ts';

// Re-export from store-registry.ts
export { registerStore, getStore, getDefaultStore } from './store/store-registry.ts';

// Re-export from as-reactive-component.ts
export { AsReactiveComponent } from './components/base/as-reactive-component.ts';
import { devlog, redirTo } from './logic/utils.ts';


export const AsUtils = {
  devlog,
  redirTo
}

// Re-export types from as-components.d.ts
export type {
  IReactiveComponent,
  IReactiveStore,
  SubbedProps,
  UpdateHandler,
  EventBinding,
  EventBindingMap
} from './as-components.d.ts';

// Re-export from as-api.ts
export { AsApi } from './logic/asApi.ts';
export type { UserData } from './logic/asApi.ts';

// License display helpers (shared by app headers and as-home user management)
export { getLicenseInfo, licenseDaysRemaining, parseLicenseDate } from './logic/license.ts';
export type { LicenseInfo, LicenseData } from './logic/license.ts';
export { AsText } from './components/text-and-lang/as-text.ts';

// Re-export core internals for advanced usage/demos
export { currentProjectData } from './data/projectManagement.ts';
export { qry } from './logic/qry.ts';
export { AsConfigurator } from './components/paramate/as-configurator.ts';
export { AsGuiCtrls } from './components/viewport/as-gui-ctrls.ts';
export { AsCheckbox } from './components/inputs/as-checkbox.ts';
export { AsDropdown } from './components/inputs/as-dropdown.ts';

// Re-export from as-app config
export { getAppInfo, getAppSettings, getAppConfig, getAppSuiteConfig, appList, filterCategories } from './components/as-app/app-config.ts';
export type { AppSettings, AppConfig, AppSuiteConfig, HubSpotConfig } from './components/as-app/app-config.ts';
export { AsApp } from './components/as-app/as-app.ts';
export { AS_APP_EL as AS_APP } from './data/app-ref.ts';

// Environment-agnostic file saving (native dialog in hosted envs, browser download otherwise)
export { saveFileAs, registerFileSaveProvider } from './logic/fileSave.ts';
export type { FileSaveOptions, FileSaveResult, FileSaveProvider } from './logic/fileSave.ts';

// File import providers for <as-file-upload> (host envs replace the open/drop flow)
export { registerFileImportProvider } from './components/file/fileImportProvider.ts';
export type { FileImportProvider, FileImportContext, ImportedFile } from './components/file/fileImportProvider.ts';

// Re-export from events.ts
export { AS_EVENTS } from './data/events.ts';
export type { AsEventName } from './data/events.ts';
import { type AsEventName } from './data/events.ts';

/**
 * Dispatch a custom event globally (on window) or to a specific target.
 * 
 * @param evName - The name of the event (use AS_EVENTS constants).
 * @param detail - Optional data to include in the event detail.
 * @param target - Optional target: string selector, HTMLElement, or Window. Defaults to window.
 */
export function sendEv(evName: AsEventName, detail: any = {}, target: string | HTMLElement | Window = window): void {
  const el = typeof target === 'string' ? document.querySelector(target) : target;
  if (!el) {
    console.warn(`[sendEv] Target not found: ${target}`);
    return;
  }
  el.dispatchEvent(new CustomEvent(evName, {
    bubbles: true,
    composed: true,
    detail
  }));
}


// export { serverCodes } from './data/constants.ts';
// Note: localisedText exports are removed as they are still work in progress 
